import { styled } from '@mui/material';

export const StyledMessageWithTipContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down(850)]: {
        paddingTop: '34px',
        paddingBottom: '34px',
    },
    gap: 20,
}));

export const StyledWidthWrapper = styled('div')(({ theme }) => ({
    width: '60%',
    [theme.breakpoints.down(1400)]: {
        width: '80%',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 20,
}));

export const IconContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
}));
